let apiRoot = '//steins.bluestonehk.com/api'
let steinsRoot = '//steins.bluestonehk.com'
let enstatineRoot = '//enstatine.bluestonehk.com'
let bluestoneH5Root = '//bluestoneh5.bluestonehk.com'
let href = location.href
let env = 'production';
if (href.indexOf('shitouji.') >= 0) {
  // 测试环境1
  apiRoot = '//test-steins.bluestonehk.com/api'
  steinsRoot = '//test-steins.bluestonehk.com'
  enstatineRoot = '//test-enstatine.bluestonehk.com'
  bluestoneH5Root='//test-bluestoneh5.bluestonehk.com'
  env='test'
} else if (href.indexOf('shitouji2.') >= 0) {
  // 测试环境2
  apiRoot = '//test2-steins.bluestonehk.com/api'
  steinsRoot = '//test2-steins.bluestonehk.com'
  enstatineRoot = '//test2-enstatine.bluestonehk.com'
  bluestoneH5Root='//test2-bluestoneh5.bluestonehk.com'
  env='test'
} else if (
  href.indexOf('dockerbj.') >= 0 ||
  href.indexOf('docker.') >= 0 ||
  href.indexOf('127.') >= 0 ||
  href.indexOf('localhost') >= 0 ||
  /192\.168\.\d{1,3}\.\d{1,3}/.test(href)
) {
  // apiRoot = '//shitouji.bluestonehk.com:5060/api'
  // steinsRoot = '//shitouji.bluestonehk.com:5060'
  // crystalRoot = '//shitouji.bluestonehk.com'
  // enstatineRoot = '//shitouji.bluestonehk.com:5070'
  // bluestoneH5Root='//localhost:9010'
  // env='docker'
  apiRoot = '//test-steins.bluestonehk.com/api'
  steinsRoot = '//test-steins.bluestonehk.com'
  enstatineRoot = '//test-enstatine.bluestonehk.com'
  bluestoneH5Root='//test-bluestoneh5.bluestonehk.com'
  env='test'
}
const config = {
  name: env,
  title: '青石证券-港股开户_美股开户_海外基金_海外投资理财综合券商',
  baseApi: apiRoot,
  enstatineHost: enstatineRoot,
  steinsHost: steinsRoot,
  bluestoneH5Root:bluestoneH5Root,
  $cdnApi: '//upload.qiniup.com/', // 上传api
  $cdn1: '//cdn1.bluestonehk.com/',
  $cdn2: '//cdn2.bluestonehk.com/'
}

module.exports = config



// WEBPACK FOOTER //
// ./src/config/index.js